var API = "";

//Setup mMenü
var $menu = $("#mmenu").mmenu({
    // OPTIONS

    // Trennstrich zwischen mMenu-Items soll über die ganze Breite gehen
    // Die zur Seite geschobene Seite soll schwarz ausgedimmt werden
    extensions: ["pagedim-black", "fx-panels-slide-100", "fx-listitems-drop", "border-full"],

    onClick: {
        "setSelected": {
            "parent": true
        }
    }

}, {
    // CONFIGURATION

    // Das Hauptmenü soll nicht verschoben sondern als mMenü kopiert werden,
    // so dass die ursprüngliche Version für Tablet und Desktop erhalten bleibt.
    clone: true,


    // Das mMenü soll #wrapper als Inhalt von <Body> benutzen um die Seite zu schieben.
    offCanvas: {
        pageSelector: ".page"
    },

    className: {
        selected: "active"
    },
    classNames: {
        selected: "active",
        fixedElements: {
            fixed: "fixed"
        }
    },
    fixedElements: {
        elemInsertMethod: "prependTo",
        elemInsertSelector: "body"
    }
});


// Deklaration des Hamburgers über den das mMenü aufgerufen werden soll
var $icon = $("#hamburger");


// Deklaration der mmenu API
API = $menu.data("mmenu");


// mMenü öffnen / schließen bei Klick auf Hamburger
$icon.on("click", function () {
    if ($(this).hasClass("is-active")) {
        API.close();
    } else {
        API.open();
    }
});

// Beim ersten Öffnen des mMenü soll das Untermenü der aktuellen Seite angezeigt werden.
var $once = false;
var $mm = $(".menu .item.open>.mm-next").attr("href");
API.bind("open:start", function () {
    if (!$once && typeof $mm !== 'undefined') {
        API.openPanel($($mm));
        $once = true;
    }
});

// Animation des Hamburgers wenn das mMenü öffnet / schließt
API.bind("open:finish", function () {
    setTimeout(function () {
        $icon.addClass("is-active");
    }, 100);
});
API.bind("close:finish", function () {
    setTimeout(function () {
        $icon.removeClass("is-active");
    }, 100);
});

// Zusätzliche Menus ins MMenu einfügen
var global = $("#footermenu>.item").clone();
$("#mm-mainmenu").find(".mm-listview").append(global);
API.initPanels($("#mm-mainmenu"));


// Add close-action to list of actions triggered on changing width to desktop
changes.large.push(function(){API.close();});